import {remCalc} from '_themeUtils'

interface StyleProps {
    colorMode: 'light' | 'dark'
    isInSidebar: boolean
    enableMultiDigitTag: boolean
}

const headerLink = {
    HeaderLink: {
        baseStyle: ({colorMode, isInSidebar, enableMultiDigitTag}: StyleProps) => ({
            // Given to the wrapper to update the color of the icon and text
            linkWrapper: {
                position: 'relative',
                cursor: 'pointer',
                gap: 'spacing.1',
                alignItems: 'center',
                justifycontent: 'center',
                color: {base: 'color.text.black', xl: colorMode === 'light' ? 'color.text.white' : 'color.text.black'},
                px: isInSidebar && 'spacing.6',
                py: isInSidebar && 'spacing.4',
                _hover: !isInSidebar && {
                    '>p': {
                        borderBottomColor: colorMode === 'light' ? 'color.border.white' : 'color.border.black',
                    },
                },
                _focus: {
                    outline: '2px solid #1e90ff',
                    boxShadow: 'none',
                },
            },
            // Telephone has a custom behaviour for display
            linkText: {
                display: {base: 'block', lg: 'none', xl: 'block'},
                textStyle: 'paragraphXs',
                fontWeight: 400,
                letterSpacing: 0.8,
                borderBottom: '1px solid',
                borderBottomColor: 'color.border.transparent',
                transition: 'all .15s ease-in-out',
            },
            tagWrapper: {
                position: 'absolute',
                top: remCalc(-6),
                right: enableMultiDigitTag ? remCalc(-12) : remCalc(-8),
            },
        }),
    },
}

export default headerLink
